import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cab37404"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-text-capitalize p-mt-6" }, "My Content", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "plus" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "add")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Add new Content", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "p-mb-5" }
const _hoisted_7 = { class: "p-d-flex p-flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchBar = _resolveComponent("SearchBar")!
  const _component_LatestContentItem = _resolveComponent("LatestContentItem")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    ($setup.user.isCreator())
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "create-campaign p-mb-6",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'content-manager', params: { creatorID: $setup.user?.id }})))
        }, _hoisted_5))
      : _createCommentVNode("", true),
    _createVNode(_component_SearchBar, {
      style: {"padding-right":"4%"},
      onClearFilters: $setup.clearFilters,
      onSelectAll: $setup.selectAllPlatforms,
      onAddPlatform: $setup.addPlatform,
      "options-name": 'platforms',
      options: $setup.platformsOptions,
      placeholder: 'Search for Content'
    }, null, 8, ["onClearFilters", "onSelectAll", "onAddPlatform", "options"]),
    _createElementVNode("div", null, [
      _createElementVNode("h4", _hoisted_6, _toDisplayString($setup.latestContent?.totalResults) + " items", 1),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.latestContent?.contentItems, (item, index) => {
          return (_openBlock(), _createBlock(_component_LatestContentItem, {
            item: item,
            key: `${index}_gfd`
          }, null, 8, ["item"]))
        }), 128))
      ])
    ])
  ]))
}